import React  from "react"
import { graphql, Link } from "gatsby"
import PropTypes from "prop-types"

import Header from "./Header"
import Heading from "./Heading"
import Image from "./Image"
import Button from "./Button"

import styles from "./hero.module.scss"
import linkStyles from "./link.module.scss"
import settings from "./settings.module.scss"

import { toTitleCase } from "../helpers"


const Hero = ({ data, customStyles, location, navigate }) => {

  const {
    layout,
    image,
    button,
    imageOverlay,
    heading,
    text,
    url,
    imageAlignment,
    contentAlignment,
    textColor,
    textColorMobile,
    navTheme,
  } = data

  const layoutType = toTitleCase(layout || "original")
  // const imageAlign = (imageAlignment)
  //   ? toTitleCase(imageAlignment.horizontalVertical).replace(/\s/g,"")
  //   : "CenterMiddle"
  const imageAlign = (imageAlignment)
    ? imageAlignment.horizontalVertical.replace("middle","center")
    : "center center"
  const contentAlign = (contentAlignment)
    ? toTitleCase(contentAlignment.horizontalVertical).replace(/\s/g,"")
    : "CenterMiddle"
  const colorScheme = toTitleCase(textColor || "light")
  const colorSchemeMobile = toTitleCase(textColorMobile || textColor || "light")

  const sectionStyle = [
    styles.hero,
    styles[`layout${layoutType}`],
    settings[`contentAlign${contentAlign}`],
    settings[`colorScheme${colorScheme}`],
    settings[`colorSchemeMobile${colorSchemeMobile}`],
    (customStyles) ? customStyles.hero : "",
  ].join(" ")
  const imageOverlaystyle = [
    styles.imageOverlay,
    settings.imageOverlay,
    (customStyles) ? customStyles.imageOverlay : "",
  ].join(" ")
  const headingStyle = [
    styles.heading1,
    settings.heading1,
    (customStyles) ? customStyles.heading1 : "",
  ].join(" ")
  const subHeadingStyle = [
    styles.subHeading,
    settings.subHeading,
    (customStyles) ? customStyles.subHeading : "",
  ].join(" ")
  const btnStyle = [
    styles.btn,
    settings.btn,
    (customStyles) ? customStyles.btn : "",
  ].join(" ")

  return (
    <section className={sectionStyle}>
      {location.pathname === "/" &&
        <Header
          location={location}
          navigate={navigate}
          navTheme={navTheme}
        />
      }
      {image && image.mobileImage &&
        <Image
          image={image}
          options={{ sizing: "art-directed", alignment: imageAlign }}
          className={styles.imageHero}
          customStyles={{ position: "absolute" }}
        />
      }
      {button && button.style === "Button" &&
        <Button
          type={button.type}
          url={button.url}
          color={button.color}
          outline={button.outline}
          className={btnStyle}
        >
          {button.text}
        </Button>
      }
      {imageOverlay &&
        <Image
          image={imageOverlay}
          altText={imageOverlay.altText}
          options={{ sizing: "art-directed" }}
          className={imageOverlaystyle}
        />
      }
      {heading &&
        <Heading
          tag="h1"
          level="1"
          className={headingStyle}
        >
          {heading.heading}
        </Heading>
      }
      {text &&
        <p
          className={subHeadingStyle}
        >
          {text.text}
        </p>
      }
      {url &&
        <Link
          to={`${url}${(url.includes("?")) ? "&" : "?"}origin=${data.componentName.toLowerCase().replace(/\s/g, "-")}`}
          className={linkStyles.linkFull}
        />
      }
    </section>
  )
}

Hero.propTypes = {
  data: PropTypes.object.isRequired,
  customStyles: PropTypes.object,
}

export default Hero

export const query = graphql`
  fragment HeroFragment on ContentfulFullWidthImage {
    componentName
    slug
    layout
    image {
      desktopImage {
        fluid(maxWidth: 2560, quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      mobileImage {
        fluid(maxWidth: 768, quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      altText
    }
    imageAlignment {
      horizontalVertical
    }
    imageOverlay {
      desktopImage {
        file {
          url
          contentType
        }
      }
      mobileImage {
        file {
          url
          contentType
        }
      }
      altText
    }
    heading {
      ...HeadingFragment
    }
    text {
      text
    }
    button {
      ...ButtonFragment
    }
    textColor
    textColorMobile
    navTheme
    contentAlignment {
      horizontalVertical
    }
    url
    internal {
      type
    }
    id
  }
`
